const faqEvents = {
  action: "faq",
  labels: {
    click: (id) => `click:${id}`,
  },
};

export default faqEvents;
